angular.module('jv.ReqsDetails', [
    'jv',
    'jv.ApprovalDir',
    'ngSanitize',
    'jv.Common.Directives.jvTinymce',
    'jv.Pending.Approvals.Service',
    'jv.Common.Directives.Datepicker',
    'jv.Common.Modal',
    'jv.Requisition.Analytics.Controller',
    'highcharts-ng',
    'jv.common.numberFormatter.directive',
    'jv.apply-form-preview.service',
    'jv.Admin.CustomFormField.directive',
    'App.video.service',
    'jv.candidates.service',
    'jv.quickView',
    'jv.applicantGrid.controller',
    'jv.candidate.modal.controller',
    'jv.Common.TemplateLoader',
    'jv.rejectCandidate.controller',
    'jv.changeStatus.controller',
    'jv.Common.AjaxSelect',
    'jv.Hire.Url.Service',
    'jv.common.currency.directive',
    'jv.React.CandidateComponent',
    'jv.common.currency.applyfield.directive',
    'jv.requisition.summary.controller',
    'jv.requisition.activities.controller',
    'jv.requisition.details.controller',
    'jv.requisition.notes.controller',
    'jv.requisition.candidates.controller',
    'jv.requisition.form.controller',
    'jv.requisition.jobLink.controller',
    'jv.requisition.jobTarget.controller',
    'jv.requisition.linkedIn.controller',
    'jv.requisition.retract.controller',
    'jv.requisition.eQuest.controller',
    'jv.requisition.tabs.controller',
    'jv.Common.Directives.MessageTemplate',
    'jv.requisition.liRecommendations.controller',
    'jv.requisition.lijobpostingstatus.controller'
], ['$routeProvider', function($routeProvider) {

    /*** Routing templates***/
    var summary = {
        controller: 'ReqsSummaryCtrl',
        templateUrl: 'tabs/summary.html',
        reloadOnSearch: false
    };
    var details = {
        controller: 'ReqsDetailsCtrl',
        templateUrl: 'tabs/details.html',
        reloadOnSearch: false
    };
    var candidates = {
        controller: 'ReqsCandidatesCtrl',
        templateUrl: 'tabs/candidates.html',
        reloadOnSearch: false
    };
    var lirecommendations = {
        controller: 'ReqsLiRecommendationsCtrl',
        templateUrl: window.jvUrls.jhire+'/common/licommon.html',
        reloadOnSearch: false
    };
    var form = {
        controller: 'ReqsFormCtrl',
        templateUrl: 'form.html',
        reloadOnSearch: false
    };
    var notes = {
        controller: 'ReqsNotesCtrl',
        templateUrl: 'tabs/notes.html',
        reloadOnSearch: false
    };
    var activities = {
        controller: 'ReqsActivitiesCtrl',
        templateUrl: 'tabs/activities.html',
        reloadOnSearch: false
    };
    var analytics = {
        controller: 'jv.Requisition.Analytics.Controller',
        templateUrl: 'tabs/analytics.html',
        reloadOnSearch: false
    };
    
    var lipostingstatus = {
            controller: 'ReqsLiJobPostingStatusCtrl',
            templateUrl: 'tabs/lijobpostingstatus.html',
            reloadOnSearch: false
    };
    
    $routeProvider.when('/summary/:id', summary);
    $routeProvider.when('/summary/:id/:index', summary);
    $routeProvider.when('/summary/:id/:index/:count', summary);
    $routeProvider.when('/summary/:id?/:index/:count/:query', summary);
    $routeProvider.when('/summary/:id/:index?/:count?/:query?', summary);

    $routeProvider.when('/details/:id', details);
    $routeProvider.when('/details/:id/:index', details);
    $routeProvider.when('/details/:id/:index/:count', details);
    $routeProvider.when('/details/:id/:index?/:count?/:query?', details);
    $routeProvider.when('/details/:id?/:index/:count/:query', details);

    $routeProvider.when('/lirecommendations/:id', lirecommendations);
    $routeProvider.when('/lirecommendations/:id/:index', lirecommendations);
    $routeProvider.when('/lirecommendations/:id/:index/:count', lirecommendations);
    $routeProvider.when('/lirecommendations/:id/:index?/:count?/:query?', lirecommendations);
    $routeProvider.when('/lirecommendations/:id?/:index/:count/:query', lirecommendations);


    $routeProvider.when('/details-edit/:id', form);
    $routeProvider.when('/details-edit/:id/:index', form);
    $routeProvider.when('/details-edit/:id/:index/:count', form);
    $routeProvider.when('/details-edit/:id/:index?/:count?/:query?', form);

    $routeProvider.when('/notes/:id', notes);
    $routeProvider.when('/notes/:id/:index', notes);
    $routeProvider.when('/notes/:id/:index/:count', notes);
    $routeProvider.when('/notes/:id/:index/:count/:query', notes);
    $routeProvider.when('/notes/:id?/:index?/:count?/:query?', notes);

    $routeProvider.when('/candidates/:id', candidates);

    $routeProvider.when('/activities/:id', activities);
    $routeProvider.when('/activities/:id/:index', activities);
    $routeProvider.when('/activities/:id/:index/:count', activities);
    $routeProvider.when('/activities/:id/:index/:count/:query', activities);
    $routeProvider.when('/activities/:id?/:index?/:count?/:query?', activities);

    $routeProvider.when('/analytics/:id', analytics);
    $routeProvider.when('/analytics/:id/:index', analytics);
    $routeProvider.when('/analytics/:id/:index/:count', analytics);
    $routeProvider.when('/analytics/:id/:index/:count/:query', analytics);
    $routeProvider.when('/analytics/:id?/:index?/:count?/:query?', analytics);

    $routeProvider.when('/lijobstatus/:id', lipostingstatus);
    $routeProvider.when('/lijobstatus/:id/:index', lipostingstatus);
    $routeProvider.when('/lijobstatus/:id/:index/:count', lipostingstatus);
    $routeProvider.when('/lijobstatus/:id/:index?/:count?/:query?', lipostingstatus);
    $routeProvider.when('/lijobstatus/:id?/:index/:count/:query', lipostingstatus);

    
    $routeProvider.otherwise({
        redirectTo: function() {
            self.location = window.jvUrls.jhire + '/modules/requisitions/list.html';
        }
    });
}]).config(['$locationProvider', function($locationProvider){
    $locationProvider.hashPrefix('');
}]);
